import { lazyLoading } from '../../utils/helpers';
import Auth from '../../middleware/auth';
import CustomizingLoader from '../../utils/CustomizingLoader';

let routes = [];

export default routes;
